const modalCTAs = document.querySelectorAll(".btn--cta");
const modalCloseButtons = document.querySelectorAll(".modal__close");
const modals = document.querySelectorAll(".modal");

modalCTAs.forEach((modalCTA) => {
  modalCTA.addEventListener("click", (e) => {
    e.preventDefault();
    const modalTarget = modalCTA.dataset.modalTarget;
    const modal = document.getElementById(modalTarget);
    if (modal) {
      modal.classList.add("modal--active");
    }
  });
});

modalCloseButtons.forEach((modalClose) => {
  modalClose.addEventListener("click", () => {
    const modal = modalClose.closest(".modal");
    if (modal) {
      modal.classList.remove("modal--active");
    }
  });
});
